/**
 * Проверяет, «попадает» ли текущая ширина окна в заданный mobile-first
 * медиадиапазон (≤ breakpoint).
 *
 * | size | breakpoint (px) | Что значит                              |
 * |------|-----------------|-----------------------------------------|
 * | `'lg'` | ≤ 1199         | крупные планшеты / маленькие десктопы  |
 * | `'md'` | ≤  991         | планшеты (ориентация «альбом»)         |
 * | `'sm'` | ≤  767         | смартфоны                               |
 * | `'xs'` | ≤  575         | очень маленькие экраны                 |
 *
 * @param  size  Ключ брейкпоинта (`'lg' | 'md' | 'sm' | 'xs'`).
 * @returns      `true`, если `window.innerWidth` не превышает порог.
 */
export const isMedia = (size: 'lg' | 'md' | 'sm' | 'xs'): boolean => {
	let screen = 0;

	switch (size) {
		case 'lg': {
			screen = 1199;
			break;
		}
		case 'md': {
			screen = 991;
			break;
		}
		case 'sm': {
			screen = 767;
			break;
		}
		case 'xs': {
			screen = 575;
			break;
		}
		default: {
			break;
		}
	}

	return window.innerWidth <= screen;
};

export type Size = 'lg' | 'md' | 'sm' | 'xs';
